import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Barracks() {
  return (
    <ImageCollectionPage 
      title="Barracks" 
      path="/barracks" 
      collection="barracks" 
    />
  );
}
